import CrudPage from "@/components/app/CrudPage";
import { formatTL, formatDate } from "@/lib/api";

export default function IncomingPaymentsPage() {
  return (
    <CrudPage
      title="Gelen Ödemeler"
      subtitle="Müşteri firmalardan tahsil edilen ödemeler."
      endpoint="/incoming-payments"
      testidPrefix="incoming"
      fields={[
        { key: "company_name", label: "Firma Adı", type: "text", required: true },
        { key: "invoice_no", label: "Fatura / Referans", type: "text" },
        { key: "date", label: "Ödeme Tarihi", type: "date", required: true },
        { key: "amount", label: "Tutar (₺)", type: "number", required: true },
        { key: "status", label: "Durum", type: "select",
          options: [{ value: "received", label: "Alındı" }, { value: "pending", label: "Beklemede" }] },
        { key: "notes", label: "Notlar", type: "textarea" },
      ]}
      columns={[
        { key: "date", label: "Tarih", render: (r) => formatDate(r.date) },
        { key: "company_name", label: "Firma" },
        { key: "invoice_no", label: "Fatura" },
        { key: "amount", label: "Tutar", align: "right", render: (r) => <span className="text-[#16A34A] font-semibold">{formatTL(r.amount)}</span> },
        { key: "status", label: "Durum" },
      ]}
    />
  );
}
